var map = {
	"./xx0.png": "OLTT",
	"./xx1.png": "9bzr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c4oC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/xx.*\.png$
// module id = c4oC
// module chunks = 3